/* eslint max-len:0 */
/* eslint-disable react/no-typos */
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';

import styles from './LoadingIndicator.css';

export default function LoadingIndicator({ className }) {
  return (
    <SvgIcon
      viewBox="0 0 50 50"
      className={`${styles['component-animate']} ${className}`}
      aria-busy="true"
    >
      <path
        fill="currentColor"
        d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
      />
    </SvgIcon>
  );
}

LoadingIndicator.propTypes = {
  className: SvgIcon.propTypes.className
};

LoadingIndicator.defaultProps = {
  className: ''
};

LoadingIndicator.displayName = 'LoadingIndicator';
